// [5.3] HotelFormStep1B.jsx – location & contact
import React, { useState, useEffect } from "react";

const COUNTRY_OPTIONS = [
  "Botswana",
  "South Africa",
  "Kenya",
  "Ghana",
  "Nigeria",
  "Tanzania",
  "Namibia",
  "Zambia",
  "Zimbabwe",
  "Uganda"
];

export default function HotelFormStep1B({ hotelData, setHotelData, errors = {} }) {
  const [isCustomCountry, setIsCustomCountry] = useState(false);

  // Initialize country on component mount
  useEffect(() => {
    if (!hotelData.Country && COUNTRY_OPTIONS.length > 0) {
      setHotelData(prev => ({
        ...prev,
        Country: prev.Country || COUNTRY_OPTIONS[0]
      }));
    }
  }, [hotelData.Country, setHotelData]);

  const handleChange = e => {
    setHotelData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleCountrySelect = e => {
    const value = e.target.value;
    if (value === "other") {
      setIsCustomCountry(true);
      setHotelData(prev => ({ ...prev, Country: "" }));
    } else {
      setIsCustomCountry(false);
      setHotelData(prev => ({ ...prev, Country: value }));
    }
  };

  return (
    <div>
      <h2>Facility Location - Step 1B</h2>
      
      <div className="form-group">
        <label>District</label>
        <input 
          name="District" 
          value={hotelData.District || ""} 
          onChange={handleChange} 
          style={{ borderColor: errors.District ? "red" : "" }} 
        />
        {errors.District && <p className="error-message">{errors.District}</p>}
      </div>

      <div className="form-group">
        <label>Province</label>
        <input 
          name="Province" 
          value={hotelData.Province || ""} 
          onChange={handleChange} 
          style={{ borderColor: errors.Province ? "red" : "" }} 
        />
        {errors.Province && <p className="error-message">{errors.Province}</p>}
      </div>

      <div className="form-group">
        <label>Country</label>
        <select 
          value={isCustomCountry ? "other" : (hotelData.Country || "")} 
          onChange={handleCountrySelect} 
          style={{ borderColor: errors.Country ? "red" : "" }}
        >
          {COUNTRY_OPTIONS.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
          <option value="other">Other (Type Manually)</option>
        </select>
        
        {isCustomCountry && (
          <input 
            name="Country" 
            placeholder="Type your country" 
            value={hotelData.Country || ""} 
            onChange={handleChange} 
            style={{ marginTop: "0.5rem", borderColor: errors.Country ? "red" : "" }} 
          />
        )}
        {errors.Country && <p className="error-message">{errors.Country}</p>}
      </div>

      <div className="form-group">
        <label>Email</label>
        <input 
          name="Email" 
          value={hotelData.Email || ""} 
          onChange={handleChange} 
          style={{ borderColor: errors.Email ? "red" : "" }} 
        />
        {errors.Email && <p className="error-message">{errors.Email}</p>}
      </div>

     <div className="form-group">
      <label>Website</label>
      <input
        type="url"                                 // empty is allowed; validates only if non-empty
        name="Website"
        placeholder="https://example.com"
        value={hotelData.Website ?? ""}            // use ?? not ||
        onChange={(e) =>
          setHotelData(p => ({ ...p, Website: e.target.value }))
        }
        onBlur={(e) => {                           // trim → null if blank/whitespace
          const s = e.target.value.trim();
          setHotelData(p => ({ ...p, Website: s === "" ? null : s }));
        }}
        style={{ borderColor: errors.Website ? "red" : "" }}
      />
    </div>

    </div>
  );
}